<div class="dialog" data-testid="dialog-token-generate-v2">
    <div class="dialog-header">
        <h2>{{ 'shared.dialog.token-generate.heading'  | translate }}</h2>
        <a class="dialog-close" (click)="onCancel()" data-testid="dialog-token-generate-v2-close">&times;</a>
    </div>
    <div class="dialog-body">
        <div class="form-row">
            <label>{{ 'shared.label.label' | translate }}</label>
            <input type="text" required name="label" maxlength="100" [(ngModel)]="model.label" data-testid="dialog-token-generate-v2-label-input">
        </div>

        <div class="form-row">
            <label>{{ 'shared.label.type' | translate }}</label>
            <select name="type" [(ngModel)]="model.type" data-testid="dialog-token-generate-v2-type-select">
                <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
            </select>
        </div>

        <div class="form-row">
            <label>{{ 'shared.label.scopes' | translate }}</label>
            <div class="checkbox-group" data-testid="dialog-token-generate-v2-scopes">
                <label *ngFor="let scope of availableScopes" class="checkbox-label">
                    <input type="checkbox" [value]="scope" (change)="onScopeToggle(scope, $event)">
                    {{ scope }}
                </label>
            </div>
        </div>

        <div class="form-row">
            <label>{{ 'shared.table.ttl' | translate }}</label>
            <div class="ttl-row">
                <input type="number" min="1" name="ttl" [(ngModel)]="model.ttl" placeholder="3600" data-testid="dialog-token-generate-v2-ttl-input">
                <span class="ttl-unit">s</span>
            </div>
            <span class="form-hint">{{ 'technicals.tokens.form.ttl-hint' | translate }}</span>
        </div>

        <div class="buttons buttons-flex">
            <a class="button button-basic-primary" (click)="onCancel()" data-testid="dialog-token-generate-v2-cancel-btn">{{ 'shared.button.cancel' | translate }}</a>
            <a class="button button-primary" [class.disabled]="!canConfirm()" (click)="onConfirm()" data-testid="dialog-token-generate-v2-confirm-btn">{{ 'shared.button.confirm' | translate }}</a>
        </div>
    </div>
</div>
